









import { Component, Prop, Vue } from "vue-property-decorator";
import { MiraFact } from "@/utils/MiraDryingView";

/** A short list of labelled facts under a figure, the values right-aligned in one column. */
@Component
export default class MiraFactsComponent extends Vue {
  @Prop({ required: true })
  facts!: MiraFact[];
}
